export default {
    isOverlayActive({ overlaysActive }) {
        return overlaysActive && overlaysActive > 0;
    },
};
